import forms from "@tailwindcss/forms";
import typography from "@tailwindcss/typography";
import animate from "tailwindcss-animate";
import { styles } from "./styles";
// const defaultTheme = require("tailwindcss/defaultTheme")
// const brandColors = require("./styles")
const config = {
    content: [
        "./public/**/*.html",
        "./app/**/*.{js,jsx,ts,tsx,vue}",
        "./pages/**/*.{js,jsx,ts,tsx,vue}"
    ],
    darkMode: "class",
    theme: {
        extend: {
            maxWidth: {
                "8xl": "88rem"
            },
            keyframes: {
                "fade-in-down": {
                    "0%": {
                        opacity: "0",
                        transform: "translateY(-10px)"
                    },
                    "100%": {
                        opacity: "1",
                        transform: "translateY(0)"
                    }
                },
                "fade-out-down": {
                    from: {
                        opacity: "1",
                        transform: "translateY(0px)"
                    },
                    to: {
                        opacity: "0",
                        transform: "translateY(10px)"
                    }
                },
                "fade-in-up": {
                    "0%": {
                        opacity: "0",
                        transform: "translateY(10px)"
                    },
                    "100%": {
                        opacity: "1",
                        transform: "translateY(0)"
                    }
                },
                "fade-out-up": {
                    from: {
                        opacity: "1",
                        transform: "translateY(0px)"
                    },
                    to: {
                        opacity: "0",
                        transform: "translateY(10px)"
                    }
                },
                shimmer: {
                    "0%": {
                        backgroundPosition: "100% center"
                    },
                    "100%": {
                        backgroundPosition: "0% center"
                    }
                }
            },
            animation: {
                "fade-in-down": "fade-in-down 1s ease-out infinite alternate",
                "fade-out-down": "fade-out-down 1s ease-out infinite alternate",
                "fade-in-up": "fade-in-up 1s ease-out infinite alternate",
                "fade-out-up": "fade-out-up 1s ease-out infinite alternate",
                shimmer: "shimmer 2s linear infinite"
            },
            colors: {
                grayscale: {
                    darkest: styles.grayscale_darkest,
                    darker: styles.grayscale_darker,
                    dark: styles.grayscale_dark,
                    medium: styles.grayscale_medium,
                    light: styles.grayscale_light,
                    lighter: styles.grayscale_lighter,
                    lightest: styles.grayscale_lightest
                },
                border: {
                    light: styles.border_light,
                    lighter: styles.border_lighter,
                    DEFAULT: styles.border
                },
                gray: {
                    table: "#747678"
                },
                brand: {
                    primary: "#74FFF1",
                    secondary: "#CACACA",
                    tertiary: "#2C3137"
                },
                white: styles.white,
                // TODO: Remove accent completely
                accent: {
                    primary: styles.accent,
                    light: styles.accent_light,
                    dark: styles.accent_dark
                },
                alert: {
                    primary: styles.alert,
                    background: styles.alert_background
                },
                warn: {
                    primary: "#FDE68A",
                    background: "#D97706"
                },
                muted: {
                    DEFAULT: styles.muted,
                    foreground: styles.muted_foreground
                },
                foreground: {
                    DEFAULT: styles.foreground
                },
                secondary: {
                    foreground: styles.secondary_foreground
                },
                inverse: {
                    foreground: styles.inverse_foreground
                },
                input: {
                    DEFAULT: styles.input
                },
                ring: {
                    DEFAULT: styles.ring
                }
            },
            typography (theme) {
                return {
                    DEFAULT: {
                        css: {
                            color: "rgba(255, 255, 255, 0.85)",
                            fontSize: "18px",
                            h1: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.4xl"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.8"),
                                marginBottom: theme("spacing.6")
                            },
                            h2: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.3xl"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.8"),
                                marginBottom: theme("spacing.6")
                            },
                            h3: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.2xl"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.6"),
                                marginBottom: theme("spacing.4")
                            },
                            h4: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.xl"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.4"),
                                marginBottom: theme("spacing.2")
                            },
                            h5: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.lg"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.4"),
                                marginBottom: theme("spacing.2")
                            },
                            h6: {
                                color: "#ffffff",
                                fontSize: theme("fontSize.base"),
                                fontWeight: theme("fontWeight.bold"),
                                lineHeight: theme("lineHeight.tight"),
                                marginTop: theme("spacing.4"),
                                marginBottom: theme("spacing.2")
                            },
                            blockquote: {
                                color: "rgba(255,255,255,1)",
                                borderLeftColor: "#75FFF1",
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: theme("fontSize.lg")
                            },
                            code: {
                                color: "#75FFF1",
                                backgroundColor: "#75FFF125",
                                padding: "0.25rem 0.4rem",
                                margin: "0 0.25rem",
                                borderRadius: theme("borderRadius.md")
                            },
                            "code::before": {
                                content: "none"
                            },
                            "code::after": {
                                content: "none"
                            },
                            "b, u, em": {
                                color: "#ffffff"
                            },
                            u: {
                                textDecoration: "underline",
                                textDecorationColor: "#ffffff",
                                textDecorationThickness: "0.2rem"
                            },
                            a: {
                                color: "#ffffff",
                                textDecoration: "underline",
                                textDecorationColor: "#75FFF1",
                                textDecorationThickness: "0.2rem",
                                margin: "0 0.1rem",
                                transition: "all 0.1s ease-in-out"
                            },
                            "a:hover": {
                                color: "rgba(255,255,255,0.3)",
                                textDecoration: "underline",
                                textDecorationColor: "rgba(255,255,255,0.1)",
                                textDecorationThickness: "0.2rem",
                                margin: "0 0.1rem"
                            },
                            "li p, table p": {
                                margin: "0px"
                            },
                            hr: {
                                borderColor: "rgba(255,255,255,0.1)",
                                marginTop: theme("spacing.8"),
                                marginBottom: theme("spacing.8")
                            },
                            table: {
                                backgroundColor: styles.grayscale_dark,
                                marginTop: theme("spacing.8"),
                                marginBottom: theme("spacing.8"),
                                borderRadius: "10px !important",
                                outline: "1px solid rgba(255,255,255,0.1)"
                            },
                            th: {
                                padding: "0.5rem 1rem",
                                textTransform: "uppercase",
                                fontWeight: "400",
                                fontSize: "0.75rem",
                                letterSpacing: "0.1rem",
                                color: "rgba(255,255,255,0.5)"
                            },
                            td: {
                                padding: "0.5rem 1rem",
                                textTransform: "none"
                            },
                            tr: {
                                borderBottom: "1px solid rgba(255,255,255,0.1)"
                            },
                            "tr:last-child": {
                                borderBottomWidth: "0px !important"
                            },
                            "ul, ol": {
                                marginTop: "0px !important",
                                marginBottom: "0px !important"
                            },
                            "ol > li::marker": {
                                fontWeight: "600",
                                color: "#75FFF1"
                            },
                            "ul > li::marker": {
                                color: "#75FFF1",
                                fontWeight: "1000"
                            },
                            strong: {
                                color: "#ffffff"
                            }
                        }
                    }
                };
            },
            boxShadow: {
                "inner-gloss": "inset 0 0 10px rgb(255 255 255 / 1%), 0 5px 30px rgb(0 0 0 / 40%)",
                "elevation-max": "0 5px 30px rgb(0 0 0 / 40%)"
            },
            fontFamily: {
                sans: [
                    "Rubik",
                    "sans-serif"
                ]
            },
            borderRadius: {
                xl: "0.625rem",
                "2xl": "1.125rem"
            },
            scale: {
                102: "1.02",
                96: "0.96"
            },
            opacity: {
                7: "0.07"
            }
        }
    },
    variants: {
        extend: {
            typography: [
                "dark"
            ]
        }
    },
    plugins: [
        forms,
        typography,
        animate
    ]
};
export { config };
